/* Election Candidate Data Service
 * 
 * Angular module: trackerbase-app.services.election-candidate-data-service
 * Exported service instance:
 *  ElectionCandidateData
 */

import angular from "angular";

import Assert from "tbAssert";

//Used for the module name. Service itself is injected by angular's dependency injector.
import ElectionDataServiceModule from "./ElectionDataService";

const mElectionDataSvc = new WeakMap();
const mQSvc = new WeakMap();

class ElectionCandidateDataService {
    constructor($q, ElectionData) {
        Assert.StrictAssert($q != null, "Assertion Failure: Missing Q Service Dependency");
        Assert.StrictAssert(ElectionData != null, "Assertion Failure: Missing Election Data Service Dependency");

        mQSvc.set(this, $q);
        mElectionDataSvc.set(this, ElectionData);

        this.serviceName = "ElectionCandidateData";
    }

    toString() {
        return this.serviceName;
    }
    
    addCandidate(electionId, trackingTargetId, candidacyStartDate, candidacyEndDate) {
        let addCandidatePromise =
            mElectionDataSvc.get(this)
                .addCandidate(
                    {
                        electionId: electionId,
                        trackingTargetId: trackingTargetId
                    },
                    {
                        CandidacyStartDate: candidacyStartDate,
                        CandidacyEndDate: candidacyEndDate
                    }
                )
                .$promise
                .then(
                    (electionData) => {
                        return electionData.result;
                    },
                    (errorResponse) => {
                        return mQSvc.get(this).reject(errorResponse);
                    }
                );
    
        return addCandidatePromise;
    }
    
    removeCandidate(electionId, trackingTargetId) {
        let removeCandidatePromise =
            mElectionDataSvc.get(this)
                .removeCandidate(
                    {
                        electionId: electionId,
                        trackingTargetId: trackingTargetId
                    }
                )
                .$promise
                .then(
                    (electionData) => {
                        return electionData.result;
                    },
                    (errorResponse) => {
                        return mQSvc.get(this).reject(errorResponse);
                    }
                );

        return removeCandidatePromise;
    }

    updateCandidate(electionId, trackingTargetId, candidacyStartDate, candidacyEndDate) {
        let updateCandidatePromise =
            mElectionDataSvc.get(this)
                .updateCandidate(
                    {
                        electionId: electionId,
                        trackingTargetId: trackingTargetId
                    },
                    {
                        CandidacyStartDate: candidacyStartDate,
                        CandidacyEndDate: candidacyEndDate
                    }
                )
                .$promise
                .then(
                    (electionData) => {
                        return electionData.result;
                    },
                    (errorResponse) => {
                        return mQSvc.get(this).reject(errorResponse);
                    }
                );

        return updateCandidatePromise;
    }
}

ElectionCandidateDataService.$inject = [ "$q", "ElectionData" ];

export default angular
    .module("trackerbase-app.services.election-candidate-data-service", [
        ElectionDataServiceModule
    ])
    .service("ElectionCandidateData", ElectionCandidateDataService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/ElectionCandidateDataService.js
// module id = v6yD
// module chunks = 1